import {fixed2} from 'app/utils/fixed';

export const formatCurrency = (amount: string | number, playmoney = false): string => {
    const fixedAmount = fixed2(amount);

    if (playmoney) {
        return `${fixedAmount} PM`;
    }

    return `$${fixedAmount}`;
};

